<!-- Dropdown header: click to show/hide meal per day graph and food log -->
<div class="foodlog-dropdown-header row mt-3 score-align-row" (click)="toggleMealPerDayFoodLog()" role="button" tabindex="0" (keydown.enter)="toggleMealPerDayFoodLog()" (keydown.space)="toggleMealPerDayFoodLog(); $event.preventDefault()">
  <div class="col-auto d-flex align-items-center">
    <span class="foodlog-dropdown-arrow" [class.expanded]="mealPerDayFoodLogExpanded" aria-hidden="true"></span>
    <p class="foodlog-dropdown-title mb-0 ms-2">Meal per day graph &amp; Food log</p>
  </div>
</div>

<!-- Collapsible content: meal per day graph + food log -->
<div class="foodlog-dropdown-content" *ngIf="mealPerDayFoodLogExpanded">
  <!-- Meals per Day Graph (Total vs Goal) -->
  <div class="chart-container mt-3" style="width: 90%;" *ngIf="showMealsChart">
    <highcharts-chart [Highcharts]="Highcharts"
      [options]="mealsChartOptions"
      [(update)]="mealsChartUpdateFlag"
      [oneToOne]="mealsChartOneToOne"
      [runOutsideAngular]="mealsChartRunOutsideAngular"
      style="width: 100%; height: 100%; display: block;">
    </highcharts-chart>
  </div>

  <div class="row mt-5 flex floatLeft w-100  py-3">
    <mat-list-item class="tab" [ngClass]="{'active': selectedType === 'All'}" role="listitem" (click)="foodFilter('All')">
        <div>
            <div class="tabContent">All</div>
        </div>
    </mat-list-item>
    <mat-list-item class="tab" [ngClass]="{'active': selectedType === 'Breakfast'}" role="listitem" (click)="foodFilter('Breakfast')">
        <div>
            <div class="tabContent">Breakfast</div>
        </div>
    </mat-list-item>
    <mat-list-item class="tab" [ngClass]="{'active': selectedType === 'Lunch'}" role="listitem" (click)="foodFilter('Lunch')">
        <div>
            <div class="tabContent">Lunch</div>
        </div>
    </mat-list-item>
    <mat-list-item class="tab" [ngClass]="{'active': selectedType === 'Dinner'}" role="listitem" (click)="foodFilter('Dinner')">
        <div>
            <div class="tabContent">Dinner</div>
        </div>
    </mat-list-item>
    <mat-list-item class="tab" [ngClass]="{'active': selectedType === 'Snack'}" role="listitem" (click)="foodFilter('Snack')">
        <div>
            <div class="tabContent">Snack</div>
        </div>
    </mat-list-item>
</div>

<!-- <div class="col-md-4 mt-4">
    <div class="dateClass">{{currentDateFormat}}</div>
    <hr>
</div> -->
<div class="col-md-12 floatLeft">
<div class="row" *ngFor='let food of foodDetails;'>
    <div class="col-md-4 mt-5">
        <div class="dateClass">{{food.date?.split('T')[0] | date:'MMMM dd, y'}}</div>
        <hr>
    </div>
    
     <div class="col-md-12">
  <app-total-nutri [foodInfo]="food"  *ngIf="this.foodDetails.length > 0"></app-total-nutri>
  </div>
  


<div class="col-md-12 mt-3 foodLog" *ngIf="this.foodDetails.length > 0">
   <app-all-logs
     *ngFor="let foodInfo of food.foodLogsInfo;"
     [foodAllInfo]="foodInfo"
     [member]="memberId"
     [startDate]="startDate"
     [endDate]="endDate"
     [selectedType]="selectedType"
     [highlightId]="selectedFoodLogId"
     [parentDate]="food.date"
     (deleted)="handleFoodDeleted()">
   </app-all-logs>
   <div class="col-md-12" *ngIf="food.foodLogsInfo.length < 1">
      No food log available for this meal category.
   </div>
</div>

</div>

<div class="row mt-5 flex floatLeft" *ngIf="this.foodDetails.length < 1">
    No Record Found..
</div>
</div>